export enum ENotificationType {
  SMS = 'SMS',
  EMAIL = 'EMAIL'
}
